(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('Dashboard', Dashboard);

    Dashboard.$inject = ['$resource'];

    function Dashboard($resource) {
        var resourceUrl = 'api/dashboards/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'mapped': {
                url: 'api/dashboards/mapped',
                method: 'GET'
            },
            'frame': {
                url: 'api/dashboards/frame/:frameReference',
                method: 'GET'
            }
        });
    }
})();
